import { APIURL } from "../models/api-base";
import {
  apiURL_live_start_notification,
  apiUrl_lives,
} from "../models/api-urls";
import fetchService from "../modules/APIService";

class Service extends fetchService {
  constructor() {
    super(APIURL);
  }

  upload = async (data, onProgress) => {
    try {
      const endpoint = apiUrl_lives;
      const response = await this.post(endpoint, data, {
        onUploadProgress: (progressEvent) => {
          if (onProgress && progressEvent.total) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            onProgress(percent);
          }
        },
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  /**
   * Envio Notificacion push
   * @returns
   */
  sendStartLiveNotification = async () => {
    try {
      const response = await this.post(apiURL_live_start_notification);
      return response;
    } catch (error) {
      throw error;
    }
  };
}

const LiveService = new Service();

export default LiveService;
